import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AdminService } from '../admin.service';
import { Logs } from './logs.model';
import { AdminConst } from '../const';
import { CoreService } from '../../../core/header/core.service';
import { DummyComponent } from '../../../shared/dummy.component';

@Component({
    selector: 'convfact-adminlog-list',
    templateUrl: './log-list.component.html',
    styleUrls: ['./log.component.css'],
    standalone: false
})

export class AdminLogListComponent implements OnInit {
  logErrorList: Logs[] = [];
  readyLog: boolean = false;

  headerTableLogs: any[] = AdminConst.headerTableLogs;

  constructor(
    private coreService: CoreService,
    private router: Router,
    public snackBar: MatSnackBar,
    private adminService: AdminService,
    public dialog: MatDialog,
    public dummy: DummyComponent
  ) { }

  ngOnInit() {

    this.coreService.setName('Panel de administración');
    this.readyLog = false;

    this.adminService.GetLogError().then(
      log => {
        this.readyLog = true;
        this.logErrorList = log;
      }, data => { // error en caso de que no sea el admin
        this.router.navigate(['/resume']);
      }
    );

    this.adminService.testNewVersion()
      .subscribe(response => {
        console.log(response);
      }, error => {
        console.log(error);
      });
  }

}
